export default {"src":"/_next/static/image/public/images/icons4/5.5bd67f336c1b053144e58e2c3f8a2cef.svg","height":43,"width":43};